'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="sl">
      <body>
        <div style={{
          display: 'flex',
          minHeight: '100vh',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          fontFamily: 'system-ui, sans-serif',
        }}>
          <h1 style={{ fontSize: '3rem', color: '#888' }}>500</h1>
          <h2>Sistemska napaka</h2>
          <p style={{ color: '#666' }}>
            Prišlo je do nepričakovane napake. Prosimo, poskusite znova.
          </p>
          <button
            onClick={reset}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              borderRadius: '0.375rem',
              backgroundColor: '#0f172a',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Poskusi znova
          </button>
        </div>
      </body>
    </html>
  );
}
